import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, noop, orderBy } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { toDefaultDateTimeFormat } from 'helpers/utils';

const styles = () => ({
  btnMore: {
    color: '#e4675a',
  },
});

class Activities extends Component {
  state = {
    isMoreVisible: false,
  };

  sliceResults = (activities = [], showAll = false) =>
    (this.state.isMoreVisible || showAll ? activities : activities.slice(0, 3));

  render() {
    let { isMoreVisible } = this.state;
    const { classes, currentUser, formatMessage, order, currentActivity, onClick
      , showAll } = this.props;
    const { orderActivities } = order;
    if (showAll) {
      isMoreVisible = true;
    }
    return (
      <div className="activities-wrapper">
        {
          this.sliceResults(orderBy(orderActivities, ['createdAt'], ['desc']), showAll).map((activity, index) => {
            const contact = activity.editorId === order.sellerId ? order.seller : order.buyer;
            let fullName = activity.editorId === currentUser.id && !activity.editorMember ? 'You' : `${get(contact, 'account.profile.companyName')}`;
            if (activity.editorMember) {
              fullName = `${get(activity, 'editorMember.profile.firstName') || ''} ${get(activity, 'editorMember.profile.lastName') || ''} (${fullName})`;
            }
            const field = formatMessage(activity.field);
            if (field === 'deliveryFee') {
              // eslint-disable-next-line no-param-reassign
              activity.from = activity.from && activity.from.indexOf('$') !== -1 ? activity.from.replace('%', '') : `$${activity.from.replace('%', '')}`;
              // eslint-disable-next-line no-param-reassign
              activity.to = activity.to && activity.to.indexOf('$') !== -1 ? activity.to.replace('%', '') : `$${activity.to.replace('%', '')}`;
            }
            let description = '';
            if (field === 'quantity' || field === 'refund quantity' || field === 'new item' ) {
              description = `${get(activity, 'orderItem.data.productData.name')} - ${get(activity, 'orderItem.data.productData.subname')}`;
            }

            const time = toDefaultDateTimeFormat(activity.createdAt);

            if (field === 'new item') {
              return (
                <div
                  className={`activity ${currentActivity.id === activity.id && 'active'} d-flex align-items-center pt-2 pb-2`}
                  key={index}
                  onClick={() => onClick(activity)}
                >
                  <div style={{ color: '#4695ec' }}>
                    <span className="activity-title" style={{ fontWeight: 'bold' }}>{`${fullName}: `}</span>
                    <span>{formatMessage('added')} </span>
                    <span style={{ fontWeight: 'bold' }}>{field}</span>
                    <span> {description} </span>
                  </div>
                  <span className="time" style={{ fontSize: 11, color: '#333333', marginLeft: 10 }}>{time}</span>
                </div>
                );
            } else {

              return (
                <div
                  className={`activity ${currentActivity.id === activity.id && 'active'} d-flex align-items-center pt-2 pb-2`}
                  key={index}
                  onClick={() => onClick(activity)}
                >
                  <div style={{ color: '#4695ec' }}>
                    <span className="activity-title" style={{ fontWeight: 'bold' }}>{`${fullName}: `}</span>
                    <span>{description} {formatMessage('updated')} </span>
                    <span style={{ fontWeight: 'bold' }}>{`${field === 'quantity' ? 'Qty' : field} ${formatMessage('from')} ${activity.from} ${formatMessage('to')} ${activity.to} `}</span>
                  </div>
                  <span className="time" style={{ fontSize: 11, color: '#333333', marginLeft: 10 }}>{time}</span>
                </div>
              );
            }
          })
        }
        {!isMoreVisible && orderActivities.length > 3 &&
          <Button
            classes={{ root: classes.btnMore }}
            onClick={() => this.setState({ isMoreVisible: !isMoreVisible })}
            id="activities"
          >
            {formatMessage('Show More')}
            <ExpandMoreIcon />
          </Button>
        }
      </div>
    );
  }
}

Activities.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  currentUser: PropTypes.shape({}),
  order: PropTypes.shape({
    orderActivities: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  currentActivity: PropTypes.shape({}),
  formatMessage: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  showAll: PropTypes.bool.isRequired,
};

Activities.defaultProps = {
  currentUser: {},
  currentActivity: {},
  order: { orderActivities: [] },
  onClick: noop,
};

export default withStyles(styles)(Activities);
